import { useEffect } from 'react';
import { navigate } from 'vike/client/router';

import { isIosNative } from '@/renderer/utils/isIosNative';

/**
 * iOS reader-app belt-and-braces for `/order/*` (App Store 3.1.1).
 *
 * `+guard.ts` redirects iOS users on client-side navigation, which is how the
 * order tree is normally reached (the native shell always cold-boots at `/`).
 * A page reload inside the app (the loading-screen "Reload" link, a WebView
 * process restart) boots the prerendered `/order` shell directly, where the
 * guard does not get a chance to run before the page mounts. Mount-time
 * redirect here, rendering nothing in the meantime, so no checkout UI ever
 * paints on iOS. No-op on web and Android.
 */
export default function OrderLayout({ children }: { children: React.ReactNode }) {
  const ios = isIosNative();

  useEffect(() => {
    if (ios) {
      navigate('/release-center');
    }
  }, [ios]);

  if (ios) {
    return null;
  }

  return <>{children}</>;
}
